module.exports = __webpack_public_path__ + "img/orange_021.3c72f391.png";